import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const highCholesterol: AnswerPathTreeNode = {
  path: 'highCholesterol',
  children: [
    { path: 'details', nodeId: NodeIds.healthInsuredCirculatorySystemCholesterolDetails },
    { path: 'diagnosisDate', nodeId: NodeIds.healthInsuredHighCholesterolDiagnosisDate },
    {
      path: 'isControlled',
      nodeId: NodeIds.healthInsuredHighCholesterolConditionIsControlled,
    },
    { path: 'highCholesterolDetails', nodeId: NodeIds.healthInsuredHighCholesterolDetails },
    { path: 'medicationDetails', nodeId: NodeIds.healthInsuredHighCholesterolMedicationDetails },
    { path: 'noMedicationReason', nodeId: NodeIds.healthInsuredHighCholesterolNoMedicationReason },
  ],
};
